/**
 * Hybrid Page V2 Controller
 */

import React, { useCallback } from 'react';
import { AnalyticsController } from 'analytics/analytics-controller';
import {
  GTM_MOBILE_FILTER_BAR_ALL_FILTERS_CLICK,
  GTM_MOBILE_FILTER_BAR_SORT_CHANGED,
  GTM_MOBILE_FILTER_BAR_SAVE_SEARCH_CLICK,
} from 'constants/events';
import HybridPageV2View from './hybrid-page-v2-view';
import type { HybridPageV2ViewProps, HybridPageV2ViewMethods } from './hybrid-page-v2-view';
import type { Sort } from 'contexts/preferences/listing-params/types';

export type HybridPageV2ControllerProps = HybridPageV2ViewProps;

/**
 * HybridPageV2Controller
 */
export const HybridPageV2Controller = React.forwardRef<HybridPageV2ViewMethods, HybridPageV2ControllerProps>(
  function HybridPageV2Controller(props, ref) {
    // Analytics handlers for MobileListingFilterBarV2
    const handleFilterButtonClickAnalytics = useCallback(() => {
      AnalyticsController.trackEvent(
        GTM_MOBILE_FILTER_BAR_ALL_FILTERS_CLICK,
        'Search Filters'
      );
    }, []);

    const handleSortChangedAnalytics = useCallback((_sort: Sort) => {
      AnalyticsController.trackEvent(
        GTM_MOBILE_FILTER_BAR_SORT_CHANGED,
        'Search Filters',
        _sort
      );
    }, []);

    const handleSaveSearchButtonClickAnalytics = useCallback(() => {
      AnalyticsController.trackEvent(
        GTM_MOBILE_FILTER_BAR_SAVE_SEARCH_CLICK,
        'User Interaction'
      );
    }, []);

    return (
      <HybridPageV2View
        ref={ref}
        {...props}
        onFilterButtonClickAnalytics={handleFilterButtonClickAnalytics}
        onSortChangedAnalytics={handleSortChangedAnalytics}
        onSaveSearchButtonClickAnalytics={handleSaveSearchButtonClickAnalytics}
      />
    );
  }
);

export default HybridPageV2Controller;
